
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setDialogCreateNewPasswordConfirmedVisible, setLoginVisible } from "../Slice/DialogSlice";
import { AppDispatch, RootState } from "../Store";

/**
 * @author noone 
 */
export default function AuthDialogCreateNewPasswordConfirm() {

    const navigate = useNavigate();
    const createNewPasswordConfirm = useSelector((state: RootState) => state.authReducer.dialog.createNewPasswordConfirmedVisible);
    const dispatch = useDispatch<AppDispatch>();

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <div>
                <h3>New password confirmed successful!</h3>
            </div>
        </div>
    );

    const footerContent = (
        <div>
            <Button
                label="LOGIN"
                onClick={() => {
                    dispatch(setDialogCreateNewPasswordConfirmedVisible(false));
                    dispatch(setLoginVisible(true));
                }} />
        </div>
    );

    return (
        <Dialog
            header={headerElement}
            footer={footerContent}
            visible={createNewPasswordConfirm}
            style={{ width: '50vw' }}
            onHide={() => {
                    dispatch(setDialogCreateNewPasswordConfirmedVisible(false));
                    navigate('/');
                }
            }
        >
            <i className={classNames("bi bi-check-circle")} style={{ fontSize: '2.5rem' }}></i>
            <p>
                Passwort erfolgreich gesetzt.
            </p>
        </Dialog>
    )

}